
import React from 'react';
import { Recipe } from '@/types/recipe';
import { MealCompositionWithRecipes } from '@/types/mealComposition';
import CalendarHistoryTile from './CalendarHistoryTile';

interface CalendarDayProps {
  date: Date;
  itemsData: { type: 'recipe' | 'composition'; item: Recipe | MealCompositionWithRecipes; mealType: 'breakfast' | 'lunch' | 'dinner'; authorFirstName?: string }[] | null;
  isToday: boolean;
}

const CalendarDay: React.FC<CalendarDayProps> = ({ date, itemsData, isToday }) => {
  return (
    <CalendarHistoryTile
      date={date}
      itemsData={itemsData}
      isToday={isToday}
    />
  );
};

export default CalendarDay;
